import React from 'react';
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, FaYoutube } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import KaroTrukkLogo from '../Common/KaroTrukkLogo';
import './Footer.css';

const Footer = () => {
    const { t } = useLanguage();
    return (
        <footer className="site-footer">
            <div className="footer-top page-width">
                <div className="footer-brand">
                    <div className="footer-logo">
                        <Link to="/" aria-label="KaroTrukk Home">
                            <KaroTrukkLogo className="h-8 w-auto hover:opacity-90 transition-opacity" color="#FFC72C" />
                        </Link>
                    </div>
                    <div className="social-links">
                        <p>{t('followUs')}</p>
                        <div className="icons">
                            <a href="/"><FaFacebookF /></a>
                            <a href="/"><FaTwitter /></a>
                            <a href="/"><FaInstagram /></a>
                            <a href="/"><FaLinkedinIn /></a>
                            <a href="/"><FaYoutube /></a>
                        </div>
                    </div>
                </div>

                <div className="footer-links-grid">
                    <div className="footer-column">
                        <h4>{t('company')}</h4>
                        <ul>
                            <li><Link to="/about">{t('aboutUs')}</Link></li>
                            <li><Link to="/careers">{t('careers')}</Link></li>
                            <li><Link to="/blog">{t('blog')}</Link></li>
                        </ul>
                    </div>

                    <div className="footer-column">
                        <h4>{t('quickLinks')}</h4>
                        <ul>
                            <li><Link to="/water-tanker">Water Tanker</Link></li>
                            <li><Link to="/general-equipment-rentals">Equipment Rentals</Link></li>
                            <li><Link to="/general-heavy-trucks">Trucks</Link></li>
                            <li><Link to="/general-construction-vehicles">JCBs & Cranes</Link></li>
                            <li><a href="https://karossstore.in" target="_blank" rel="noopener noreferrer">KarossStore (GPS)</a></li>
                        </ul>
                    </div>

                    <div className="footer-column">
                        <h4>{t('support')}</h4>
                        <ul>
                            <li><Link to="/contact">{t('contactUs')}</Link></li>
                            <li><Link to="/help">{t('helpCenter') || 'Help Center'}</Link></li>
                            <li><Link to="/privacy">{t('privacyPolicy')}</Link></li>
                            <li><Link to="/terms">{t('termsOfService')}</Link></li>
                            <li><Link to="/insurance">{t('insuranceFaqs')}</Link></li>
                        </ul>
                    </div>

                    <div className="footer-column">
                        <h4>{t('countries')}</h4>
                        <ul>
                            <li><a href="/">India</a></li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="footer-cities page-width">
                <h4>{t('tnCities')}</h4>
                <div className="cities-grid">
                    <ul>
                        <li>Chennai</li>
                        <li>Coimbatore</li>
                        <li>Madurai</li>
                        <li>Tiruchirappalli</li>
                        <li>Salem</li>
                    </ul>
                    <ul>
                        <li>Tiruppur</li>
                        <li>Erode</li>
                        <li>Vellore</li>
                        <li>Thoothukudi</li>
                        <li>Tirunelveli</li>
                    </ul>
                    <ul>
                        <li>Thanjavur</li>
                        <li>Dindigul</li>
                        <li>Ranipet</li>
                        <li>Sivakasi</li>
                        <li>Karur</li>
                    </ul>
                    <ul>
                        <li>Ooty</li>
                        <li>Hosur</li>
                        <li>Nagercoil</li>
                        <li>Kanchipuram</li>
                        <li>Karaikudi</li>
                    </ul>
                </div>
            </div>

            <div className="footer-bottom page-width">
                <p>© 2024 KaroTrukk. {t('allRightsReserved')}</p>
            </div>
        </footer>
    );
};

export default Footer;
